












































































import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';
import api from '@/infrastructure/api/api';
import {権限レベル区分型} from '@/type/authentication/login';
import DatePicker from '@/components/datepicker/DatePicker.vue';
import DepartmentSelector from '@/components/department/DepartmentSelector.vue';
import {loginModule} from '@/store/authentication/login';
import {progress} from '@/script/progress';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import NormalDialog from '@/components/atom/dialog/NormalDialog.vue';
import {利用者初期値, 利用者型} from '@/type/user/user';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';

@Component({
  components: {
    DatePicker,
    DepartmentSelector,
    ConfirmDialog,
    NormalButton,
    NormalDialog,
    AlertDialog,
  },
})

export default class RegisterUser extends Vue {

  private 利用者登録: 利用者型 = 利用者初期値;
  private 権限レベル区分リスト: string[] = [
    権限レベル区分型.管理者,
    権限レベル区分型.利用者,
  ];
  private アラートメッセージ: string[] = [];

  @Prop({default: false})
  private modal!: boolean;

  public created(): void {
    this.init();
  }

  @Watch('modal')
  private changeDialog(nowModal: boolean, prevModal: boolean): void {
    if (nowModal) {
      this.openDialog('ログインマスタ新規画面');
    }
  }

  @Emit('close-form')
  private closeForm(): void {
    this.clear();
    this.closeDialog('ログインマスタ新規画面');
  }

  private openDialog(name: string): void {
    this.$modal.show(name);
  }

  private closeDialog(name: string): void {
    this.$modal.hide(name);
  }

  private registerHandler(): void {
    progress(this.register);
  }

  private async register(): Promise<void> {
    await api.利用者を登録する(this.利用者登録)
      .then(
        () => {
          this.closeDialog('確定ダイアログ');
          this.closeForm();
        },
        (error: any) => {
          this.closeDialog('確定ダイアログ');
          if (error.data.errors) {
            this.アラートメッセージ = error.data.errors;
          }
          if (error.data.message && !error.data.errors) {
            this.アラートメッセージ = [error.data.message];
          }
          this.openDialog('利用者登録アラート');
        },
      );
  }

  private async 部署コード初期化(): Promise<void> {
    this.利用者登録.部署コード = loginModule.部署コードを取得する;
    if (loginModule.マスターである) {
      const 部署一覧 = await api.部署一覧を取得する();
      this.利用者登録.部署コード = 部署一覧[0].部署コード;
    }
  }

  private clear(): void {
    this.init();
    this.closeDialog('クリアダイアログ');
  }

  private init(): void {
    this.利用者登録 = {...利用者初期値};
    this.アラートメッセージ = [];
    this.部署コード初期化();
  }
}
